import React from 'react';
import { useTranslation } from 'react-i18next';

export interface Requisites {
  legal_name: string;
  tax_id: string;
  legal_address: string;
  contract_number: string;
}

export const EMPTY_REQUISITES: Requisites = {
  legal_name: '', tax_id: '', legal_address: '', contract_number: '',
};

export function requisitesComplete(r: Requisites): boolean {
  return !!(r.legal_name?.trim() && r.tax_id?.trim() && r.legal_address?.trim());
}

interface Props {
  value: Requisites;
  onChange: (r: Requisites) => void;
  taxLabel?: string;     // tax-id label, e.g. BIN/IIN (KZ), EDRPOU (UA)
  required?: boolean;    // show the * marker
}

/** Legal requisites (invoice buyer details) — used in agency + client + signup forms. */
export const RequisitesFields: React.FC<Props> = ({ value, onChange, taxLabel, required = false }) => {
  const { t } = useTranslation();
  const set = (k: keyof Requisites, v: string) => onChange({ ...value, [k]: v });
  // Callers may pass their own tax-id label (EDRPOU for UA, …); default to the KZ one.
  const taxIdLabel = taxLabel ?? t('requisites.taxIdDefault');
  const star = required ? ' *' : '';
  return (
    <>
      <div className="offices-form-field">
        <label>{t('requisites.legalName')}{star}</label>
        <input type="text" value={value.legal_name || ''}
               onChange={e => set('legal_name', e.target.value)}
               placeholder={t('requisites.legalNamePh')} />
      </div>
      <div className="offices-form-field">
        <label>{taxIdLabel}{star}</label>
        <input type="text" value={value.tax_id || ''}
               onChange={e => set('tax_id', e.target.value)}
               placeholder={taxIdLabel} />
      </div>
      <div className="offices-form-field">
        <label>{t('requisites.legalAddress')}{star}</label>
        <input type="text" value={value.legal_address || ''}
               onChange={e => set('legal_address', e.target.value)}
               placeholder={t('requisites.legalAddressPh')} />
      </div>
      <div className="offices-form-field">
        <label>{t('requisites.contractNumber')}</label>
        <input type="text" value={value.contract_number || ''}
               onChange={e => set('contract_number', e.target.value)}
               placeholder={t('requisites.contractNumberPh')} />
      </div>
    </>
  );
};

export default RequisitesFields;
